import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import TemperatureHumidityChart from "../DevServices/TemperatureHumidityChart"

const SimpleModal = (props) => {
  const {title, body, update_sensor_collections, isModal, modalTitle, sensor_data_for_modal} = props
  //const [show, setShow] = useState(false);

/*   const handleClose = () => setShow(false);
  const handleShow = () => setShow(true); */
  const handleClose = () => update_sensor_collections("isModal", false);
  const handleShow = () => update_sensor_collections("isModal", true);
  return (
    <>

      <Modal show={isModal} onHide={handleClose}>
      <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
          <Button variant="close" onClick={handleClose} aria-label="Close">
            &times; {/* Cross symbol */}
          </Button>
        </Modal.Header>
        <Modal.Body>
          <TemperatureHumidityChart 
            data = {sensor_data_for_modal}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SimpleModal;